







import { getCookie } from 'tiny-cookie'
import { VUE_APP_TMS_URL } from './config'
import { isProductionUrl } from './environment-detection'

export default {
  computed: {
    isProduction() {
      return isProductionUrl()
    },
    isIframe() {
      return this.$route.query.iframe
    }
  },
  watch: {
    $route: function(val) {
      this.hideHotjarButton(val.query.iframe)
    }
  },
  created() {
    const isIframe = window.self !== window.top
    const isBetaUser = getCookie('TMSBetaUser')
    if (isBetaUser && !isIframe) window.location.href = VUE_APP_TMS_URL
  },
  mounted() {
    this.hideHotjarButton(this.$route.query.iframe)
  },
  methods: {
    hideHotjarButton(isIframe) {
      /* Hide the hotjar feedback button if the app is being loaded in an iframe */
      const rootSelector = document.querySelector(':root') as HTMLElement
      if (isIframe) {
        rootSelector.style.setProperty('--hotjarButtonVisibility', 'none')
      }
    }
  }
}
